import AppLayout from '@/layout/AppLayout.vue'
// import Home from '@/view/home/Home.vue'
const DocsApi = () => import('@/view/documents/DocsApi.vue')

const routes = [
  {
    component: AppLayout,
    children: [
      {
        path: '/docsApi',
        component: DocsApi,
        meta: { key: 'docsApi' },
      },
    ]
  },
]
const components = {}

export default {
  routes,
  components,
}
